module.exports = __webpack_public_path__ + "static/media/fa-solid-900.711643fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-solid-900.svg
// module id = 305
// module chunks = 0